"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var l10n_1 = require("@paprika/l10n");
var button_1 = __importDefault(require("@paprika/button"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var HighbondLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/HighbondLogo"));
var AppSwitcher_1 = __importDefault(require("@acl-services/wasabicons/lib/AppSwitcher"));
var sc = __importStar(require("./AppSwitcherTitle.styles"));
var ThemeProvider_1 = require("../../theme/ThemeProvider");
var propTypes = {
    children: prop_types_1.default.string,
    launchpadUrl: prop_types_1.default.string.isRequired,
    onClose: prop_types_1.default.func.isRequired,
};
var defaultProps = {
    children: '',
};
function AppSwitcherTitle(props) {
    var _a = ThemeProvider_1.useTheme(), isDiligentBrand = _a.isDiligentBrand, isTrainingOrg = _a.isTrainingOrg;
    var launchpadUrl = props.launchpadUrl, children = props.children, onClose = props.onClose;
    var i18n = l10n_1.useI18n();
    function renderAppSwitcherProductTitle() {
        if (isDiligentBrand) {
            return i18n.t('global_navigation.app_switcher_title');
        }
        else if (isTrainingOrg) {
            return i18n.t('global_navigation.training.app_switcher_product_title');
        }
        else {
            return children;
        }
    }
    return (react_1.default.createElement(sc.AppSwitcherHeading, { level: 2 },
        react_1.default.createElement(sc.AppSwitcherTitle, { "data-sri-anchor": "navigation-app-switcher.title-bar" },
            isDiligentBrand ? (react_1.default.createElement(sc.AppSwitcherLogo, { "aria-label": i18n.t('global_navigation.navigation_items.logo'), "data-sri-anchor": "navigation-app-switcher.close", onClick: onClose },
                react_1.default.createElement(AppSwitcher_1.default, { "data-sri-anchor": "navigation-app-switcher.logo-svg", color: isTrainingOrg ? tokens_1.default.color.white : tokens_1.default.color.blackLighten20 }))) : (react_1.default.createElement(sc.AppSwitcherTitleLogo, { "aria-label": i18n.t('global_navigation.navigation_items.logo'), "data-sri-anchor": "navigation-app-switcher.logo", href: launchpadUrl, target: "_top" },
                react_1.default.createElement(HighbondLogo_1.default, { "data-sri-anchor": "navigation-app-switcher.logo-svg", color: tokens_1.default.color.gold }))),
            react_1.default.createElement(sc.AppSwitcherProductTitle, { "data-sri-anchor": "navigation-app-switcher.product-title" }, renderAppSwitcherProductTitle()),
            !isDiligentBrand && (react_1.default.createElement(button_1.default.Close, { "data-pka-anchor": "panel.header.close", isSemantic: false, onClick: onClose, size: button_1.default.types.MEDIUM })))));
}
exports.default = AppSwitcherTitle;
AppSwitcherTitle.propTypes = propTypes;
AppSwitcherTitle.defaultProps = defaultProps;
//# sourceMappingURL=AppSwitcherTitle.js.map